import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import TeamManagement from './TeamManagement';
import UserManagement from './UserManagement';
import Payments from './Payments';
import ClubSettings from './ClubSettings';
import './Management.css';

function Management({ initialTab }) {
  const { hasRole } = useAuth();
  const isSportsClub = hasRole('SPORTS_CLUB');

  const tabs = [
    { key: 'teams', label: 'Drużyny' },
    ...(isSportsClub ? [{ key: 'users', label: 'Użytkownicy' }] : []),
    ...(isSportsClub ? [{ key: 'settings', label: 'Ustawienia' }] : []),
    ...(isSportsClub ? [{ key: 'payments', label: 'Płatności' }] : []),
  ];

  const [activeTab, setActiveTab] = useState(
    initialTab && tabs.some(t => t.key === initialTab) ? initialTab : 'teams'
  );

  return (
    <div className="management-container">
      <h2 className="management-title">Zarządzanie</h2>
      <div className="management-tabs">
        {tabs.map(tab => (
          <button
            key={tab.key}
            className={`management-tab ${activeTab === tab.key ? 'management-tab--active' : ''}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="management-content">
        {activeTab === 'teams' && <TeamManagement embedded />}
        {activeTab === 'users' && isSportsClub && <UserManagement embedded />}
        {activeTab === 'settings' && isSportsClub && <ClubSettings />}
        {activeTab === 'payments' && isSportsClub && <Payments embedded />}
      </div>
    </div>
  );
}

export default Management;
